import script from "./HelloWorld.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&setup=true&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=e1109bfe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1109bfe"]])

export default __exports__